import moment from 'moment';

// Import Actions
import { SET_REDIRECT, SET_MOUNTED, UPDATE_TABLE, SET_SSR_MODE, REDIRECT, SET_REFERRAL, SET_META_ATTRIBUTION, INIT_PERSISTED_DATA } from './AppActions';
import { LOGIN_USER, LOGOUT_USER } from '../User/UserActions';
import { getPersistedData, persistData } from '../../util/persistor';

// Initial State
export const initialState = {
    isSSR: false,
    redirect: '',
    redirectIndex: 0,
    isMounted: false,
    referral: null,
	referralDate: null,
    metaAttribution: null,
    tables: [
        // {
        //     id: 'users-list',
        //     activePage: 3,
        //     pageSize: null,
        //     searchFilters: [
        //         {
        //             property: 'name',
        //             value: 'test'
        //         }
        //     ],
        //     searchText: 'ma recherche'
        // }
    ],
};

const AppReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_REDIRECT:
            return {
                ...state,
                redirect: action.redirect,
            };

        case REDIRECT:
            return {
                ...state,
                redirect: state.redirect ? (action.replaceIfSet && action.redirect ? action.redirect : state.redirect) : (action.redirect || ''),
                redirectIndex: state.redirectIndex + 1,
            };

        case SET_MOUNTED:
            return {
                ...state,
                isMounted: true,
            };

        case UPDATE_TABLE:
            return {
                ...state,
                tables: [
                    ...state.tables.filter(table => table.id !== action.tableId),
                    {
                        id: action.tableId,
                        ...action.tableData,
                    },
                ],
            };

        // case LOGIN_USER:
        // case LOGOUT_USER:
        //     return {
        //         ...state,
        //         isMounted: true,
        //     };

        case SET_SSR_MODE:
            return {
                ...state,
                isSSR: action.isSSR,
            };

		case SET_REFERRAL: {
			const newState = {
				...state,
				referral: action.referral,
				referralDate: moment.utc().format(),
			};
			// Persist only referral data
			persistData('app', getDataToPersist(newState));
			return newState;
		}

		case SET_META_ATTRIBUTION: {
			const newState = {
				...state,
				metaAttribution: {
					...(state.metaAttribution || {}),
					...(action.metaAttribution || {}),
					capturedAt: moment.utc().format(),
				},
			};
			persistData('app', getDataToPersist(newState));
			return newState;
		}

        case INIT_PERSISTED_DATA: {
			const storedState = getPersistedData('app', null);
			if(storedState) {
				return {
					...state,
					...storedState,
				};
			}
			persistData('app', getDataToPersist(state));
            return state;
		}

        default:
            return state;
    }
};

function getDataToPersist(state) {
	return {
		referral: state.referral,
		referralDate: state.referralDate,
		metaAttribution: state.metaAttribution,
	};
}

// Export Reducer
export default AppReducer;
